import { render } from "./MessageList.vue?vue&type=template&id=8e0c7c28&scoped=true&ts=true"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"

import "./MessageList.vue?vue&type=style&index=0&id=8e0c7c28&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0c7c28"]])

export default __exports__